import { Form } from "react-bootstrap";
import VisuallyHiddenError from "./VisuallyHiddenError";

type InvalidFeedbackProps = {
    id: string,
    message: string
}

const FormControl = ({id, message}: InvalidFeedbackProps) => {
    return (
        <Form.Control.Feedback id={id} tabIndex={-1} type="invalid">
            <VisuallyHiddenError />
            {message}
        </Form.Control.Feedback>
    );
}
export const InvalidFeedbackFormControl = FormControl;

const P = ({id, message}: InvalidFeedbackProps) => {
    return (
        <p id={id} tabIndex={-1} className="text-danger mb-0">
            <VisuallyHiddenError />
            {message}
        </p>
    );
}
export const InvalidFeedbackP = P;


const InvalidFeedback = { FormControl,  P };
export default InvalidFeedback;